import { Tooltip, Button } from '@mantine/core';
import { IconType } from 'react-icons';

interface DrawerActionButtonProps {
  tooltipLabel: string;
  disabled?: boolean;
  onClick: () => void;
  Icon: IconType;
  isOutlineVariant?: boolean;
  loading?: boolean;
}

export const DrawerActionButton = ({
  tooltipLabel,
  disabled,
  onClick,
  Icon,
  isOutlineVariant,
  loading,
}: DrawerActionButtonProps) => {
  let icon;
  if (Icon) {
    icon = <Icon size={16} />;
  }
  return (
    <Tooltip label={tooltipLabel}>
      <Button
        loading={loading}
        size={'xs'}
        disabled={disabled}
        onClick={onClick}
        variant={isOutlineVariant ? 'outline' : 'filed'}
      >
        {icon}
      </Button>
    </Tooltip>
  );
};
